(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kp-image-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__kpOfferLinks) return;
    window.__kpOfferLinks = true;
    document.addEventListener('click', async (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-kp-to-offer]') : null;
      if (!link) return;
      event.preventDefault();
      const KP = window.KP && window.KP.scrollTo ? window.KP : await window.KPReady;
      if (!KP || !KP.scrollTo) return;
      const main = document.querySelector('kp-product');
      const target =
        (main && main.offerAnchor) ||
        document.querySelector('[data-kp-offer]') ||
        document.querySelector('[data-kp-main-atc]') ||
        document.querySelector('main form[action*="/cart/add"]');
      if (target) {
        KP.scrollTo(target, { offset: 24 });
        if (KP.flash) KP.flash(target);
      } else {
        KP.scrollTo(document.querySelector('main') || document.body);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__kpOfferLinks) return;
    window.__kpOfferLinks = true;
    document.addEventListener('click', async (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-kp-to-offer]') : null;
      if (!link) return;
      event.preventDefault();
      const KP = window.KP && window.KP.scrollTo ? window.KP : await window.KPReady;
      if (!KP || !KP.scrollTo) return;
      const main = document.querySelector('kp-product');
      const target =
        (main && main.offerAnchor) ||
        document.querySelector('[data-kp-offer]') ||
        document.querySelector('[data-kp-main-atc]') ||
        document.querySelector('main form[action*="/cart/add"]');
      if (target) {
        KP.scrollTo(target, { offset: 24 });
        if (KP.flash) KP.flash(target);
      } else {
        KP.scrollTo(document.querySelector('main') || document.body);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-rich-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__kpOfferLinks) return;
    window.__kpOfferLinks = true;
    document.addEventListener('click', async (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-kp-to-offer]') : null;
      if (!link) return;
      event.preventDefault();
      const KP = window.KP && window.KP.scrollTo ? window.KP : await window.KPReady;
      if (!KP || !KP.scrollTo) return;
      const main = document.querySelector('kp-product');
      const target =
        (main && main.offerAnchor) ||
        document.querySelector('[data-kp-offer]') ||
        document.querySelector('[data-kp-main-atc]') ||
        document.querySelector('main form[action*="/cart/add"]');
      if (target) {
        KP.scrollTo(target, { offset: 24 });
        if (KP.flash) KP.flash(target);
      } else {
        KP.scrollTo(document.querySelector('main') || document.body);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('kv-faq-accordion')) return;

    class KvFaqAccordion extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const button = event.target.closest('.kv-fq__btn');
          if (!button || !this.contains(button)) return;
          const item = button.closest('[data-kv-faq-item]');
          if (item) this.toggle(item);
        };
        this.onBlockSelect = (event) => {
          const item = event.target.closest && event.target.closest('[data-kv-faq-item]');
          if (item && this.contains(item)) this.toggle(item, true);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get items() {
        return Array.from(this.querySelectorAll('[data-kv-faq-item]'));
      }

      toggle(item, force) {
        const open = typeof force === 'boolean' ? force : !item.classList.contains('is-open');
        if (open && this.dataset.exclusive === 'true') {
          this.items.forEach((other) => {
            if (other !== item && other.classList.contains('is-open')) this.setOpen(other, false);
          });
        }
        this.setOpen(item, open);
      }

      setOpen(item, open) {
        item.classList.toggle('is-open', open);
        const button = item.querySelector('.kv-fq__btn');
        const panel = item.querySelector('.kv-fq__panel');
        if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.toggleAttribute('inert', !open);
      }
    }

    customElements.define('kv-faq-accordion', KvFaqAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-guarantee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__kvScrollTopBound) return;
    window.__kvScrollTopBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-kv-scroll-top]');
      if (!trigger) return;
      event.preventDefault();

      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const selector = (trigger.getAttribute('data-kv-target') || '').trim();
      let target = null;
      if (selector) {
        try {
          target = document.querySelector(selector);
        } catch (error) {
          target = null;
        }
      }

      if (target) {
        const header = document.querySelector('header, .header-section, #header-group');
        const offset = header ? Math.min(header.getBoundingClientRect().height, 140) + 12 : 12;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
      } else {
        window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('kv-rc-carousel')) return;

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class KvRcCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-kv-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('[data-kv-prev]');
        this.nextBtn = this.querySelector('[data-kv-next]');
        this.dotsWrap = this.querySelector('[data-kv-dots]');
        this.stops = [0];
        this.active = 0;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.update();
          });
        };
        this.onResize = () => {
          this.measure();
          this.update();
        };
        this.onScrollEnd = () => {
          this.pending = null;
          this.update();
        };
        this.onPrev = () => this.goToStop(this.current() - 1);
        this.onNext = () => this.goToStop(this.current() + 1);
        this.onBlockSelect = (event) => {
          const slide = this.slides.find((s) => s === event.target || s.contains(event.target));
          if (slide) this.goToSlide(this.slides.indexOf(slide), true);
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('scrollend', this.onScrollEnd);
        this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
        this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.onResize);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.onResize);
        }
        this.onResize();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('scrollend', this.onScrollEnd);
        clearTimeout(this.pendingTimer);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.onResize);
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      measure() {
        const track = this.track;
        this.max = Math.max(0, track.scrollWidth - track.clientWidth);
        const base = this.slides.length ? this.slides[0].offsetLeft : 0;
        const stops = [];
        this.slides.forEach((slide) => {
          const pos = Math.min(Math.max(slide.offsetLeft - base, 0), this.max);
          if (!stops.length || pos - stops[stops.length - 1] > 2) stops.push(pos);
        });
        this.stops = stops.length ? stops : [0];
        this.dataset.overflow = this.max > 2 ? 'true' : 'false';
        this.renderDots();
      }

      renderDots() {
        if (!this.dotsWrap) return;
        const count = this.stops.length > 1 ? this.stops.length : 0;
        if (this.dotsWrap.childElementCount === count) return;
        this.dotsWrap.textContent = '';
        for (let i = 0; i < count; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kv-rc__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${count}`);
          dot.addEventListener('click', () => this.goToStop(i));
          this.dotsWrap.appendChild(dot);
        }
      }

      nearest() {
        const left = this.track.scrollLeft;
        let nearest = 0;
        this.stops.forEach((pos, i) => {
          if (Math.abs(pos - left) < Math.abs(this.stops[nearest] - left)) nearest = i;
        });
        return nearest;
      }

      current() {
        return this.pending == null ? this.nearest() : this.pending;
      }

      update() {
        const active = this.current();
        const left = this.pending == null ? this.track.scrollLeft : this.stops[active];
        this.active = active;
        if (this.prevBtn) this.prevBtn.disabled = left <= 2;
        if (this.nextBtn) this.nextBtn.disabled = left >= this.max - 2;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((dot, i) => {
            const on = i === active;
            dot.classList.toggle('is-active', on);
            if (on) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }

      scrollTrack(left, instant) {
        this.track.scrollTo({ left, behavior: instant || prefersReducedMotion() ? 'auto' : 'smooth' });
      }

      goToStop(index) {
        const i = Math.max(0, Math.min(index, this.stops.length - 1));
        // Remember the target while a smooth scroll is running so rapid clicks keep advancing.
        this.pending = i;
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(this.onScrollEnd, 800);
        this.scrollTrack(this.stops[i]);
        this.update();
      }

      goToSlide(index, instant) {
        const slide = this.slides[index];
        if (!slide) return;
        this.measure();
        const pos = Math.min(Math.max(slide.offsetLeft - this.slides[0].offsetLeft, 0), this.max);
        this.scrollTrack(pos, instant);
      }
    }

    customElements.define('kv-rc-carousel', KvRcCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('kv-tm-carousel')) return;

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class KvTmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-kv-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('[data-kv-prev]');
        this.nextBtn = this.querySelector('[data-kv-next]');
        this.dotsWrap = this.querySelector('[data-kv-dots]');
        this.stops = [0];
        this.active = 0;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.update();
          });
        };
        this.onResize = () => {
          this.measure();
          this.update();
        };
        this.onScrollEnd = () => {
          this.pending = null;
          this.update();
        };
        this.onPrev = () => this.goToStop(this.current() - 1);
        this.onNext = () => this.goToStop(this.current() + 1);
        this.onBlockSelect = (event) => {
          const slide = this.slides.find((s) => s === event.target || s.contains(event.target));
          if (slide) this.goToSlide(this.slides.indexOf(slide), true);
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('scrollend', this.onScrollEnd);
        this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
        this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.onResize);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.onResize);
        }
        this.onResize();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('scrollend', this.onScrollEnd);
        clearTimeout(this.pendingTimer);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.onResize);
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      measure() {
        const track = this.track;
        this.max = Math.max(0, track.scrollWidth - track.clientWidth);
        const base = this.slides.length ? this.slides[0].offsetLeft : 0;
        const stops = [];
        this.slides.forEach((slide) => {
          const pos = Math.min(Math.max(slide.offsetLeft - base, 0), this.max);
          if (!stops.length || pos - stops[stops.length - 1] > 2) stops.push(pos);
        });
        this.stops = stops.length ? stops : [0];
        this.dataset.overflow = this.max > 2 ? 'true' : 'false';
        this.renderDots();
      }

      renderDots() {
        if (!this.dotsWrap) return;
        const count = this.stops.length > 1 ? this.stops.length : 0;
        if (this.dotsWrap.childElementCount === count) return;
        this.dotsWrap.textContent = '';
        for (let i = 0; i < count; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kv-tm__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${count}`);
          dot.addEventListener('click', () => this.goToStop(i));
          this.dotsWrap.appendChild(dot);
        }
      }

      nearest() {
        const left = this.track.scrollLeft;
        let nearest = 0;
        this.stops.forEach((pos, i) => {
          if (Math.abs(pos - left) < Math.abs(this.stops[nearest] - left)) nearest = i;
        });
        return nearest;
      }

      current() {
        return this.pending == null ? this.nearest() : this.pending;
      }

      update() {
        const active = this.current();
        const left = this.pending == null ? this.track.scrollLeft : this.stops[active];
        this.active = active;
        if (this.prevBtn) this.prevBtn.disabled = left <= 2;
        if (this.nextBtn) this.nextBtn.disabled = left >= this.max - 2;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((dot, i) => {
            const on = i === active;
            dot.classList.toggle('is-active', on);
            if (on) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }

      scrollTrack(left, instant) {
        this.track.scrollTo({ left, behavior: instant || prefersReducedMotion() ? 'auto' : 'smooth' });
      }

      goToStop(index) {
        const i = Math.max(0, Math.min(index, this.stops.length - 1));
        // Remember the target while a smooth scroll is running so rapid clicks keep advancing.
        this.pending = i;
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(this.onScrollEnd, 800);
        this.scrollTrack(this.stops[i]);
        this.update();
      }

      goToSlide(index, instant) {
        const slide = this.slides[index];
        if (!slide) return;
        this.measure();
        const pos = Math.min(Math.max(slide.offsetLeft - this.slides[0].offsetLeft, 0), this.max);
        this.scrollTrack(pos, instant);
      }
    }

    customElements.define('kv-tm-carousel', KvTmCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
